/** Install only the static local-unlock shell. No patient/API responses enter Cache Storage. */
export async function prepareOfflineShell(): Promise<void> {
  if (!('serviceWorker' in navigator)) throw new Error('Offline page installation is unavailable.');
  const registration = await navigator.serviceWorker.register('/flowsheets-sw.js', { scope: '/' });
  const worker = registration.installing ?? registration.waiting ?? registration.active;
  if (!worker) throw new Error('Offline page installation did not start.');
  if (worker.state === 'activated' || worker.state === 'installed') return;
  await new Promise<void>((resolve, reject) => {
    const timeout = window.setTimeout(() => { cleanup(); reject(new Error('Offline page installation timed out.')); }, 30000);
    const change = () => {
      if (worker.state === 'installed' || worker.state === 'activated') { cleanup(); resolve(); }
      else if (worker.state === 'redundant') { cleanup(); reject(new Error('Offline page installation failed.')); }
    };
    const cleanup = () => { window.clearTimeout(timeout); worker.removeEventListener('statechange', change); };
    worker.addEventListener('statechange', change); change();
  });
}
